// extracted by mini-css-extract-plugin
export default {"container":"OverlayFx_container__GZ3Nq","gradientAnim":"OverlayFx_gradientAnim__qIdF7","gradientMove":"OverlayFx_gradientMove__IM-Bf"};